const StopWatchSVG = ({ className }: { className?: string }) => (
    <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9997 73.3346C32.9272 73.3346 26.1445 70.5251 21.1435 65.5241C16.1425 60.5232 13.333 53.7404 13.333 46.668C13.333 39.5955 16.1425 32.8128 21.1435 27.8118C26.1445 22.8108 32.9272 20.0013 39.9997 20.0013C47.0721 20.0013 53.8549 22.8108 58.8559 27.8118C63.8568 32.8128 66.6663 39.5955 66.6663 46.668C66.6663 53.7404 63.8568 60.5232 58.8559 65.5241C53.8549 70.5251 47.0721 73.3346 39.9997 73.3346V73.3346ZM36.6497 36.668V50.0013C36.6897 52.2246 37.8097 53.3346 40.0097 53.3346C42.2097 53.3346 43.3097 52.2246 43.3097 50.0013V36.668C43.3097 34.4446 42.2097 33.3346 39.9997 33.3346C37.7897 33.3346 36.6763 34.4446 36.6497 36.668ZM33.333 6.66797H46.6497C48.8897 6.68797 50.0097 7.80464 50.0097 10.018C50.0097 12.228 48.8897 13.3346 46.6497 13.3346H33.333C31.1097 13.3346 29.9997 12.228 29.9997 10.018C29.9997 7.80464 31.1097 6.68797 33.333 6.66797ZM63.7363 12.358L68.4397 17.0613C70.0063 18.6613 70.0097 20.2413 68.4463 21.8046C66.883 23.3713 65.313 23.358 63.7263 21.7746L59.0263 17.0746C57.453 15.5013 57.4497 13.9346 59.013 12.368C60.5797 10.8046 62.153 10.8013 63.7363 12.358Z"
            fill="#4D809E"
        />
    </svg>
);

// eslint-disable-next-line import/no-default-export
export default StopWatchSVG;
